
var movie = {};

var sequence = {};
var _path = "";
var _staticPath = {
  local: 'https://op-wstatic.ncsoft.com',
  op: 'https://op-wstatic.ncsoft.com',
  rc: 'https://rc-wstatic.plaync.co.kr',
  live: 'https://wstatic-cdn.plaync.com'
};
var staticPath = (function() {
  var loc = location.href;

  var projectPath = '/promo/lineage/history/2020/201111_update/';
  _path = _staticPath.live + projectPath;

  if (/rc-/i.test(loc)) {
    _path = _staticPath.rc + projectPath;
  }
  if (/op\./i.test(loc)) {
    _path = _staticPath.op + projectPath;
  }
  if (/local\.|localhost|opdev|ui-static\.|file:/i.test(loc)) {
    _path = _staticPath.local + projectPath;
  }
})();


movie.introMovie = promokit.video({
  el: '#player-intro',
  url: 'https://vod.plaync.com/lineage/brand_episode20201109/main_3.mp4',
  preload: true,
  mute: true,
  autoplay: true,
  loop: true
});


sequence.book = promokit.sequence({
  el: '#book_name',
  path: _path+'img/pc/seq',
  prefix:"title_motion_",
  frame:180,
  fps:30,
  autoplay:true,
  loop:true,
  preload:true
});




var Aniversary = (function() {
  
  var that =this;
  var intro = new TimelineMax({paused:true}),
  scene1   = new TimelineMax({paused:true}),
  scene1_0 = new TimelineMax({paused:true}),
  scene1_1 = new TimelineMax({paused:true}),
  scene1_2 = new TimelineMax({paused:true}),
  scene2   = new TimelineMax({paused:true}), 

  scene3   = new TimelineMax({paused:true});
  scene3_1 = new TimelineMax({paused:true});
  scene3_2 = new TimelineMax({paused:true});

  scene4   = new TimelineMax({paused:true});
  scene4_1 = new TimelineMax({paused:true});
  scene4_2 = new TimelineMax({paused:true});
  
  scene5   = new TimelineMax({paused:true});
  scene5_1 = new TimelineMax({paused:true});
  scene5_2 = new TimelineMax({paused:true});
  
  scene6   = new TimelineMax({paused:true});

  scene7   = new TimelineMax({paused:true});

  scene8   = new TimelineMax({paused:true});
  scene8_1   = new TimelineMax({paused:true});
  scene8_2   = new TimelineMax({paused:true});
  scene8_3   = new TimelineMax({paused:true});



  var $intro = $('#intro'),
  $scene1 = $('#village'),
  $scene2 = $('#event'),

  $scene3 = $('#reboot1'),
  $scene4 = $('#reboot2');
  $scene5 = $('#reboot3');
  $scene6 = $('#reboot4');

  $scene7 = $('#dungeon1');
  $scene8 = $('#dungeon2');
  
  var sectionHeader = {
    id: '#intro',
    name: 'HOME',
    enterStart() {
      intro.seek(0);
      intro.play();
      update.remote(0)
    },
    enterEnd() {
    }
  };

  var section1 = {
    id: '#village',
    name: '루운성마을',
    enterStart() {
      scene1.seek(0);
      scene1.play();
      update.remote(1)
      
      var idx = update.slider.village_swiper.realIndex;
      if (idx ==0) {
        scene1_0.seek(0);
        scene1_0.play();
      }
      if (idx ==1) {
        scene1_1.seek(0);
        scene1_1.play();
      }
      if (idx ==2) {
        scene1_2.seek(0);
        scene1_2.play();
      }
      
    },
    enterEnd() {
    },
    leaveStart() {
    },
    leaveEnd() {
    }
  };

  var section2 = {
    id: '#event',
    name: '22주년 이벤트 안내',
    enterStart() {
      scene2.seek(0);
      scene2.play();
      update.remote(2)
    },
  }

  // reboot1
  var section3 = {
    id: '#reboot1',
    name: '마법사의 변화',
    enterStart() {
      scene3.seek(0);
      scene3.play();
      update.remote(3)

      var idx = update.slider.reboot1cont.realIndex;
      if (idx ==0) {
        scene3_1.seek(0);
        scene3_1.play();
      }
      if (idx ==1) {
        scene3_2.seek(0);
        scene3_2.play();
      }
      
    },
    leaveEnd() {
      
    }
  }
  // reboot2
  var section4 = {
    id: '#reboot2',
    name: '서먼 몬스터의 변화',
    enterStart() {
      scene4.seek(0);
      scene4.play();
      update.remote(4)

      var idx = update.slider.reboot2cont.realIndex;
      if (idx ==0) {
        scene4_1.seek(0);
        scene4_1.play();
      }
      if (idx ==1) {
        scene4_2.seek(0);
        scene4_2.play();
      }
      
    },
    leaveEnd() {
      
    }
  }
  //reboot3
  var section5 = {
    id: '#reboot3',
    name: '서먼 몬스터의 던전',
    enterStart() {
      scene5.seek(0);
      scene5.play();
      update.remote(5)

      var idx = update.slider.reboot3cont.realIndex;
      if (idx ==0) {
        scene5_1.seek(0);
        scene5_1.play();
      }
      if (idx ==1) {
        scene5_2.seek(0);
        scene5_2.play();
      }
    },
    leaveEnd() {
      
    }
  }
  //reboot4
  var section6 = {
    id: '#reboot4',
    name: '린모티콘 시즌2',
    enterStart() {
      scene6.seek(0);
      scene6.play();
      update.remote(6)
  
    },
    leaveEnd() {
      
    }
  }

  //dungeon1
  var section7 = {
    id: '#dungeon1',
    name: '루운성 광장',
    enterStart() {
      scene7.seek(0);
      scene7.play();
      update.remote(7)
  
    },
    leaveEnd() {
      
    }
  }
  //dungeon2
  var section8 = {
    id: '#dungeon2',
    name: '루운성 던전',
    enterStart() {
      scene8.seek(0);
      scene8.play();
      update.remote(8)
      var idx = update.slider.dungeon2cont.realIndex;
      if (idx == 0) {
        scene8_1.seek(0);
        scene8_1.play();
      }
      if (idx == 1) {
        scene8_2.seek(0);
        scene8_2.play();
      }
      if (idx == 2) {
        scene8_3.seek(0);
        scene8_3.play();
      }
    },
    leaveEnd() {

    }
  }


  function Lineage_UPDATE(opts) {
    this.page;
    this.opts = opts;
    this.selector = {
        box: "[data-scene]"
    };
    this.state = {
        y: [],
        introTimer: null,
        resizeTimer: null,
        isScrolling: false,
        rsp: false
    };
    this.scenebox = {};
    this.movie = {};
    this.layer = {};
    this.slider = {};
    
    this.init();
  }
  Lineage_UPDATE.prototype = {
    init : function() {
      //this.setPage();
      this.state.length = $(this.selector.box).length - 1;
      this.setSlide();
      this.setPage();
      //this.setMovie();
      
      this.resize();
      this.setSequence();
      this.sceneSettings();
      this.controls();

      this.setMovie();
      this.setLayer();
      this.setEvent();
    },
    setPage : function () {
      var context = this;
      this.page = promokit.page({
        type: 'fullpage-fade',
        game: 'lineage',
        menu: false, 
        cnb: true, 
    
        topButton: true, 
    
        headerButton: {
          el: '.header-button',
          cookie: {
            type: 'year', 
            key: 'INDEX_WEB_VISIT_210106_update',
            value: false
          },
          home: true, 
          event:false,
          update:true,
          sns: true,
          theme: 'black'
        },
    
        components: [
          sectionHeader,
          section1,
          section2,
          section3,
          section4,
          section5,
          section6,

          section7,
          section8
          
        ]
      });
      
      this.page.on('changeend', function({to, prev, now}) {
        //console.log('page change end:', {to, prev, now});
        if (now == 0) {
          sequence.book.play();
        }
      });
      this.page.on('changestart', function({to, prev, now}) {
        //context.remote(to);
        setTimeout(function() {
          $(window).trigger('resize');
        },10)

        if (to != 0) {
          sequence.book.stop();
        }
      });

    },
    setMovie : function() {
      
    },
    layout : function() {

    },
    setLayer : function() {
      var context = this;

    },
    setEvent : function(){
      var context = this;
      $('#menu a').on('click', function(e) {
        var num = $(this).data('anchor');
        if ($(this).data('anchor') == undefined) {
          num = $(this).closest('ul').siblings('a').eq(0).data('anchor');
        }  
      });


    },
    setSlide: function() {
      var context = this;           
      context.slider.village_swiper = new Swiper('.village_cont', {
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        allowTouchMove : false,
        noSwiping: false,
        simulateTouch: false,
        speed: 300,
        spaceBetween: 100,
        on : {
          slideChange : function() {
            var idx = context.slider.village_swiper.realIndex;
            if (idx ==0) {
              scene1_0.seek(0);
              scene1_0.play();
            }
            if (idx ==1) {
              scene1_1.seek(0);
              scene1_1.play();
            }
            if (idx ==2) {
              scene1_2.seek(0);
              scene1_2.play();
            }
          }
        }
      });

      //reboot1
      context.slider.reboot1cont = new Swiper('.reboot1cont', {
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        allowTouchMove : false,
        noSwiping: false,
        simulateTouch: false,
        speed: 300,
        spaceBetween: 100,
        on : {
          slideChange : function() {
            var idx = context.slider.reboot1cont.realIndex;
            if (idx ==0) {
              scene3_1.seek(0);
              scene3_1.play();
            }
            if (idx ==1) {
              scene3_2.seek(0);
              scene3_2.play();
              c5video.stop();
            }
          }
        }
      });
      var c5video = promokit.youtube({
        el: '#c5Video',
        youtubeid:'O1cilCxtxJk',
        controls: true
      });
      
      //reboot2
      context.slider.reboot2cont = new Swiper('.reboot2cont', {
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        allowTouchMove : false,
        noSwiping: false,
        simulateTouch: false,
        speed: 300,
        spaceBetween: 100,
        on : {
          slideChange : function() {
            var idx = context.slider.reboot2cont.realIndex;
            if (idx ==0) {
              scene4_1.seek(0);
              scene4_1.play();
            }
            if (idx ==1) {
              scene4_2.seek(0);
              scene4_2.play();
              c5video.stop();
            }
          }
        }
      });

      //reboot3
      context.slider.reboot3cont = new Swiper('.reboot3cont', {
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        allowTouchMove : false,
        noSwiping: false,
        simulateTouch: false,
        speed: 300,
        spaceBetween: 100,
        on : {
          slideChange : function() {
            var idx = context.slider.reboot3cont.realIndex;
            if (idx ==0) {
              scene5_1.seek(0);
              scene5_1.play();
            }
            if (idx ==1) {
              scene5_2.seek(0);
              scene5_2.play();
              c5video.stop();
            }
          }
        }
      });

      //dungeon2
      context.slider.dungeon2cont = new Swiper('.dungeon2cont', {
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        allowTouchMove : false,
        noSwiping: false,
        simulateTouch: false,
        speed: 300,
        spaceBetween: 100,
        on : {
          slideChange : function() {
            var idx = context.slider.dungeon2cont.realIndex;
            if (idx ==0) {
              scene8_1.seek(0);
              scene8_1.play();
            }
            if (idx ==1) {
              scene8_2.seek(0);
              scene8_2.play();
            }
            if (idx ==2) {
              scene8_3.seek(0);
              scene8_3.play();
            }
          }
        }
      });


    },
    sceneSettings: function() {
      $('#intro').addClass('page_active');
      
      intro.addLabel('init')
      .fromTo($intro.find('.bg'), 0.6,{autoAlpha:0, scale: 1.2},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init')
      .fromTo($intro.find('.intro_tit_wrap1'), 0.6,{autoAlpha:0, y: 50},{ autoAlpha:1, y: 0, ease: Power2.easeOut }, 'init+=0.2')
      .fromTo($intro.find('.intro_tit_wrap2'), 0.6,{autoAlpha:0, y: 50},{ autoAlpha:1, y: 0, ease: Power2.easeOut }, 'init+=0.4')
      .fromTo($intro.find('.floating'), 0.4,{autoAlpha:0,scale: 0.5},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init+=0.8')
      .fromTo($intro.find('.etc_menu'), 0.6,{autoAlpha:0,y:30},{ autoAlpha:1, y: 0, ease: Power2.easeOut }, 'init+=1')
      .fromTo($intro.find('.main_book'), 1.2,{autoAlpha:0,scale:0.9},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init+=0.5')
      .fromTo($intro.find('.scroll'), 0.8,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+=1')
      
      
      scene1.addLabel('init')
      .fromTo($scene1.find('.bg'), 0.6,{autoAlpha:0, scale: 1.2},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init')
      .fromTo($scene1.find('.bg_book'), 1,{autoAlpha:0, scale: 0.9},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init+=0.4')
      
      scene1_0.addLabel('init')
      .fromTo($scene1.find('.c1_img'), 19/30,{autoAlpha:0},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene1.find('.c1_img_deco0'), 20/30,{autoAlpha:0 },{ autoAlpha:1, scale: 1, x:0, y:0, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene1.find('.c1_img_deco1'), 20/30,{autoAlpha:0 },{ autoAlpha:1, scale: 1, x:0, y:0, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene1.find('.c1_img_deco2'), 20/30,{autoAlpha:0},{ autoAlpha:1, scale: 1, x:0, y:0, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene1.find('.c1_img_deco3'), 20/30,{autoAlpha:0},{ autoAlpha:1, scale: 1, x:0, y:0, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene1.find('.c1_light'), 20/30,{autoAlpha:0, scale: 0.5},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene1.find('.c1_tit'), 20/30,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene1.find('.c1_txt'), 0.8,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.5)
      .fromTo($scene1.find('.c1_cont'), 1,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.8)
      .fromTo($scene1.find('.c1_tit_dero_l'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene1.find('.c1_tit_dero_r'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      
      scene1_1.addLabel('init')
      .fromTo($scene1.find('.c2_img0'), 20/30,{autoAlpha:0},{ autoAlpha:1, scale: 1, x:0, y:0, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene1.find('.c2_img1'), 20/30,{autoAlpha:0},{ autoAlpha:1, scale: 1, x:0, y:0, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene1.find('.c2_light'), 20/30,{autoAlpha:0, scale: 0.5,  y:0},{ autoAlpha:1, scale: 1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene1.find('.c2_tit'), 20/30,{autoAlpha:0},{ autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene1.find('.c2_txt'), 0.8,{autoAlpha:0},{ autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.5)
      .fromTo($scene1.find('.c2_cont'), 1,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.8)
      .fromTo($scene1.find('.c2_tit_dero_l'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.5)
      .fromTo($scene1.find('.c2_tit_dero_r'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.5)
      
      scene1_2.addLabel('init')
      .fromTo($scene1.find('.c3_img0'), 19/30,{autoAlpha:0, x:0, y:0},{ autoAlpha:1, x:0, y:0, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene1.find('.c3_img1'), 19/30,{autoAlpha:0, x:0, y:0},{ autoAlpha:1, x:0, y:0, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene1.find('.c3_img2'), 19/30,{autoAlpha:0, x:0, y:0},{ autoAlpha:1, x:0, y:0, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene1.find('.c3_img3'), 19/30,{autoAlpha:0, x:0, y:0},{ autoAlpha:1, x:0, y:0, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene1.find('.c3_light'), 20/30,{autoAlpha:0, scale: 0.5,  y:0},{ autoAlpha:1, scale: 1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene1.find('.c3_tit'), 20/30,{autoAlpha:0,  y:0},{ autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene1.find('.c3_txt'), 0.8,{autoAlpha:0,  y:0},{ autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.5)
      .fromTo($scene1.find('.c3_tit_dero_l'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene1.find('.c3_tit_dero_r'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene1.find('.c3_tag0'), 19/30,{autoAlpha:0, y:0},{ autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.8)
      .fromTo($scene1.find('.c3_tag1'), 19/30,{autoAlpha:0, y:0},{ autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.8)
      .fromTo($scene1.find('.c3_tag2'), 19/30,{autoAlpha:0, y:0},{ autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.8)
      .fromTo($scene1.find('.c3_tag3'), 19/30,{autoAlpha:0, y:0},{ autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.8)
      
      
      scene2.addLabel('init')
      .fromTo($scene2.find('.bg'), 0.6,{autoAlpha:0, scale: 1.2},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init')
      .fromTo($scene2.find('.bg_book'), 1,{autoAlpha:0, scale: 0.9},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init+=0.4')
      .fromTo($scene2.find('.c4_img0'), 22/30,{autoAlpha:0, scale: 0.8, y:-40},{ autoAlpha:1, scale: 1, y:0, ease: Power2.easeOut }, 'init+='+0.5)
      .fromTo($scene2.find('.c4_img1'), 22/30,{autoAlpha:0, scale: 0.8, y:-40},{ autoAlpha:1, scale: 1, y:0, ease: Power2.easeOut }, 'init+='+0.5)
      .fromTo($scene2.find('.c4_img2'), 22/30,{autoAlpha:0, scale: 0.8, y:-40},{ autoAlpha:1, scale: 1, y:0, ease: Power2.easeOut }, 'init+='+0.5)
      .fromTo($scene2.find('.c4_light'), 20/30,{autoAlpha:0, scale: 0.5,  y:0},{ autoAlpha:1, scale: 1, y:0, ease: Power2.easeOut }, 'init+='+0.5)
      .fromTo($scene2.find('.c4_tit'), 20/30,{autoAlpha:0,  y:0},{ autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.5)
      .fromTo($scene2.find('.c4_txt'), 0.8,{autoAlpha:0,  y:0},{ autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene2.find('.c4_date'), 0.6,{autoAlpha:0,  y:0},{ autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.9)
      .fromTo($scene2.find('.c4_tit_dero_l'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.5)
      .fromTo($scene2.find('.c4_tit_dero_r'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.5)
      .fromTo($scene2.find('.c4_arrow0'), 10/30,{autoAlpha:0, scale: 0.5, x:-40},{ autoAlpha:1, scale: 1, x:0, ease: Power2.easeOut }, 'init+='+1.6)
      .fromTo($scene2.find('.c4_arrow1'), 10/30,{autoAlpha:0, scale: 0.5, x:-40},{ autoAlpha:1, scale: 1, x:0, ease: Power2.easeOut }, 'init+='+1.7)
      .fromTo($scene2.find('.c4_arrow2'), 10/30,{autoAlpha:0, scale: 0.5, x:-40},{ autoAlpha:1, scale: 1, x:0, ease: Power2.easeOut }, 'init+='+1.8)
      

      scene3.addLabel('init')
      .fromTo($scene3.find('.bg'), 0.6,{autoAlpha:0, scale: 1.2},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init')
      .fromTo($scene3.find('.bg_book'), 1,{autoAlpha:0, scale: 0.9},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init+=0.4')

      scene3_1.addLabel('init')
      .fromTo($scene3.find('.c5_tit'), 20/30,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene3.find('.c5_txt'), 0.8,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.5)
      .fromTo($scene3.find('.c5_light'), 20/30,{autoAlpha:0, scale: 0.5},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene3.find('.c5_video'), 1,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.8)
      .fromTo($scene3.find('.c5_tit_dero_l'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene3.find('.c5_tit_dero_r'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      
      scene3_2.addLabel('init')
      .fromTo($scene3.find('.c6_tit'), 20/30,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene3.find('.c6_txt'), 0.8,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.5)
      .fromTo($scene3.find('.c6_light'), 20/30,{autoAlpha:0, scale: 0.5},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene3.find('.c6_tit_dero_l'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene3.find('.c6_tit_dero_r'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      //.fromTo($scene3.find('.c6_cont'), 1,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.8)
      .fromTo($scene3.find('.c6_item1'), 0.8,{autoAlpha:0, scale: 0.8, y: 20,  x: 60  },{ autoAlpha:1, scale:1, y:0, x:0, ease: Power2.easeOut }, 'init+='+0.75)
      .fromTo($scene3.find('.c6_item2'), 0.7,{autoAlpha:0, scale: 0.8, y: 20,  x: 30  },{ autoAlpha:1, scale:1, y:0, x:0, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene3.find('.c6_item3'), 0.7,{autoAlpha:0, scale: 0.8, y: 20,  x: -30 },{ autoAlpha:1, scale:1, y:0, x:0, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene3.find('.c6_item4'), 0.8,{autoAlpha:0, scale: 0.8, y: 20,  x: -60 },{ autoAlpha:1, scale:1, y:0, x:0, ease: Power2.easeOut }, 'init+='+0.75)
      .fromTo($scene3.find('.c6_item5'), 0.8,{autoAlpha:0, scale: 0.8, y: -20, x:  60 },{ autoAlpha:1, scale:1, y:0, x:0, ease: Power2.easeOut }, 'init+='+0.75)
      .fromTo($scene3.find('.c6_item6'), 0.7,{autoAlpha:0, scale: 0.8, y: -20, x:  30 },{ autoAlpha:1, scale:1, y:0, x:0, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene3.find('.c6_item7'), 0.7,{autoAlpha:0, scale: 0.8, y: -20, x: -30 },{ autoAlpha:1, scale:1, y:0, x:0, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene3.find('.c6_item8'), 0.8,{autoAlpha:0, scale: 0.8, y: -20, x: -60 },{ autoAlpha:1, scale:1, y:0, x:0, ease: Power2.easeOut }, 'init+='+0.75)
      
      .fromTo($scene3.find('.c6_new1'), 0.3,{autoAlpha:0., scale: 1.8, },{ autoAlpha:1, scale:1, ease: Power2.easeOut }, 'init+='+1.2)
      .fromTo($scene3.find('.c6_new2'), 0.3,{autoAlpha:0., scale: 1.8, },{ autoAlpha:1, scale:1, ease: Power2.easeOut }, 'init+='+1.3)
      .fromTo($scene3.find('.c6_new3'), 0.3,{autoAlpha:0., scale: 1.8, },{ autoAlpha:1, scale:1, ease: Power2.easeOut }, 'init+='+1.4)
      .fromTo($scene3.find('.c6_new4'), 0.3,{autoAlpha:0., scale: 1.8, },{ autoAlpha:1, scale:1, ease: Power2.easeOut }, 'init+='+1.5)
      .fromTo($scene3.find('.c6_new5'), 0.3,{autoAlpha:0., scale: 1.8, },{ autoAlpha:1, scale:1, ease: Power2.easeOut }, 'init+='+1.6)
      .fromTo($scene3.find('.c6_new6'), 0.3,{autoAlpha:0., scale: 1.8, },{ autoAlpha:1, scale:1, ease: Power2.easeOut }, 'init+='+1.7)
      .fromTo($scene3.find('.c6_new7'), 0.3,{autoAlpha:0., scale: 1.8, },{ autoAlpha:1, scale:1, ease: Power2.easeOut }, 'init+='+1.8)
      .fromTo($scene3.find('.c6_new8'), 0.3,{autoAlpha:0., scale: 1.8, },{ autoAlpha:1, scale:1, ease: Power2.easeOut }, 'init+='+1.9)
      

      scene4.addLabel('init')
      .fromTo($scene4.find('.bg'), 0.6,{autoAlpha:0, scale: 1.2},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init')
      .fromTo($scene4.find('.bg_book'), 1,{autoAlpha:0, scale: 0.9},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init+=0.4')

      scene4_1.addLabel('init')
      .fromTo($scene4.find('.c7_tit'), 20/30,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene4.find('.c7_txt'), 0.8,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.5)
      .fromTo($scene4.find('.c7_light'), 20/30,{autoAlpha:0, scale: 0.5},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene4.find('.c7_tit_dero_l'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene4.find('.c7_tit_dero_r'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene4.find('.c7_item1'), 19/30,{autoAlpha:0, x:0, y:0},{ autoAlpha:1, x:0, y:0, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene4.find('.c7_item2'), 19/30,{autoAlpha:0, x:0, y:0},{ autoAlpha:1, x:0, y:0, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene4.find('.c7_item3'), 19/30,{autoAlpha:0, x:0, y:0},{ autoAlpha:1, x:0, y:0, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene4.find('.c7_name1'), 19/30,{autoAlpha:0, y:0},{ autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.8)
      .fromTo($scene4.find('.c7_name2'), 19/30,{autoAlpha:0, y:0},{ autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.8)
      .fromTo($scene4.find('.c7_name3'), 19/30,{autoAlpha:0, y:0},{ autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.8)

      scene4_2.addLabel('init')
      .fromTo($scene4.find('.c8_tit'), 20/30,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene4.find('.c8_txt'), 0.8,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.5)
      .fromTo($scene4.find('.c8_light'), 20/30,{autoAlpha:0, scale: 0.5},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene4.find('.c8_tit_dero_l'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene4.find('.c8_tit_dero_r'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene4.find('.c8_item1'), 19/30,{autoAlpha:0, x:0, y:0},{ autoAlpha:1, x:0, y:0, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene4.find('.c8_item2'), 19/30,{autoAlpha:0, x:0, y:0},{ autoAlpha:1, x:0, y:0, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene4.find('.c8_item3'), 19/30,{autoAlpha:0, x:0, y:0},{ autoAlpha:1, x:0, y:0, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene4.find('.c8_name1'), 19/30,{autoAlpha:0, y:0},{ autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.8)
      .fromTo($scene4.find('.c8_name2'), 19/30,{autoAlpha:0, y:0},{ autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.8)
      .fromTo($scene4.find('.c8_name3'), 19/30,{autoAlpha:0, y:0},{ autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.8)
      .fromTo($scene4.find('.c8_dot1'), 0.5,{autoAlpha:0, scale:1.5 },{ autoAlpha:1, scale:1, ease: Power2.easeOut },'init+='+0.7)
      .fromTo($scene4.find('.c8_dot2'), 0.5,{autoAlpha:0, scale:1.5 },{ autoAlpha:1, scale:1, ease: Power2.easeOut },'init+='+0.7)
      .fromTo($scene4.find('.c8_dot3'), 0.5,{autoAlpha:0, scale:1.5 },{ autoAlpha:1, scale:1, ease: Power2.easeOut },'init+='+0.7)
      .fromTo($scene4.find('.c8_desc'), 19/30,{autoAlpha:0, y:0},{ autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.9)
      .fromTo($scene4.find('.c8_desc'), 19/30,{autoAlpha:0, y:0},{ autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.9)
      .fromTo($scene4.find('.c8_desc'), 19/30,{autoAlpha:0, y:0},{ autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.9)


      scene5.addLabel('init')
      .fromTo($scene5.find('.bg'), 0.6,{autoAlpha:0, scale: 1.2},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init')
      .fromTo($scene5.find('.bg_book'), 1,{autoAlpha:0, scale: 0.9},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init+=0.4')

      scene5_1.addLabel('init')
      .fromTo($scene5.find('.c9_tit'), 20/30,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene5.find('.c9_txt'), 0.8,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.5)
      .fromTo($scene5.find('.c9_light'), 20/30,{autoAlpha:0, scale: 0.5},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene5.find('.c9_tit_dero_l'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene5.find('.c9_tit_dero_r'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene5.find('.c9_img'), 19/30,{autoAlpha:0},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene5.find('.c9_cont'), 1,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.8)

      scene5_2.addLabel('init')
      .fromTo($scene5.find('.c10_tit'), 20/30,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene5.find('.c10_txt'), 0.8,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.5)
      .fromTo($scene5.find('.c10_light'), 20/30,{autoAlpha:0, scale: 0.5},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene5.find('.c10_tit_dero_l'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene5.find('.c10_tit_dero_r'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene5.find('.c10_img1'), 0.6,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene5.find('.c10_img2'), 0.6,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene5.find('.c10_line1'), 0.4,{autoAlpha:0, scaleX:0},{ autoAlpha:1, scaleX:1, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene5.find('.c10_line2'), 0.4,{autoAlpha:0, scaleX:0},{ autoAlpha:1, scaleX:1, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene5.find('.c10_name1'), 0.4,{autoAlpha:0, x:-20},{ autoAlpha:1, x:0, ease: Power2.easeOut }, 'init+='+0.8)
      .fromTo($scene5.find('.c10_name2'), 0.4,{autoAlpha:0, x:-20},{ autoAlpha:1, x:0, ease: Power2.easeOut }, 'init+='+0.8)
      .fromTo($scene5.find('.c10_name3'), 0.4,{autoAlpha:0, x:-20},{ autoAlpha:1, x:0, ease: Power2.easeOut }, 'init+='+0.8)
      .fromTo($scene5.find('.c10_desc1'), 0.4,{autoAlpha:0, x:-20},{ autoAlpha:1, x:0, ease: Power2.easeOut }, 'init+='+0.9)
      .fromTo($scene5.find('.c10_desc2'), 0.4,{autoAlpha:0, x:-20},{ autoAlpha:1, x:0, ease: Power2.easeOut }, 'init+='+0.9)
      .fromTo($scene5.find('.c10_desc3'), 0.4,{autoAlpha:0, x:-20},{ autoAlpha:1, x:0, ease: Power2.easeOut }, 'init+='+0.9)


      scene6.addLabel('init')
      .fromTo($scene6.find('.bg'), 0.6,{autoAlpha:0, scale: 1.2},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init')
      .fromTo($scene6.find('.bg_book'), 1,{autoAlpha:0, scale: 0.9},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init+=0.4')
      .fromTo($scene6.find('.c11_tit'), 20/30,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene6.find('.c11_txt'), 0.8,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.5)
      .fromTo($scene6.find('.c11_light'), 20/30,{autoAlpha:0, scale: 0.5},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene6.find('.c11_tit_dero_l'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene6.find('.c11_tit_dero_r'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene6.find('.c11_cut1'),  0.8,{autoAlpha:0,  y:-10},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene6.find('.c11_cut2'),  0.8,{autoAlpha:0,  y:-10},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene6.find('.c11_cut3'),  0.8,{autoAlpha:0,  y:-10},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene6.find('.c11_cut4'),  0.8,{autoAlpha:0,  y:-10},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene6.find('.c11_cut5'),  0.8,{autoAlpha:0,  y:-10},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene6.find('.c11_cut6'),  0.8,{autoAlpha:0,  y:-10},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.8)
      .fromTo($scene6.find('.c11_cut7'),  0.8,{autoAlpha:0,  y:-10},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.8)
      .fromTo($scene6.find('.c11_cut8'),  0.8,{autoAlpha:0,  y:-10},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.8)
      .fromTo($scene6.find('.c11_cut9'),  0.8,{autoAlpha:0,  y:-10},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.8)
      .fromTo($scene6.find('.c11_cut10'), 0.8,{autoAlpha:0,  y:-10},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.8)
      .fromTo($scene6.find('.c11_btn'), 0.5,{autoAlpha:0,  scale:.9},{autoAlpha:1, scale:1, ease: Power2.easeOut }, 'init+='+1.0)


      scene7.addLabel('init')
      .fromTo($scene7.find('.bg'), 0.6,{autoAlpha:0, scale: 1.2},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init')
      .fromTo($scene7.find('.bg_book'), 1,{autoAlpha:0, scale: 0.9},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init+=0.4')
      .fromTo($scene7.find('.c12_tit'), 20/30,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene7.find('.c12_txt'), 0.8,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.5)
      .fromTo($scene7.find('.c12_light'), 20/30,{autoAlpha:0, scale: 0.5},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene7.find('.c12_tit_dero_l'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene7.find('.c12_tit_dero_r'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene7.find('.c12_img'), 19/30,{autoAlpha:0},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene7.find('.c12_desc'), 1,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.8)
 
      scene8.addLabel('init')
      .fromTo($scene8.find('.bg'), 0.6,{autoAlpha:0, scale: 1.2},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init')
      .fromTo($scene8.find('.bg_book'), 1,{autoAlpha:0, scale: 0.9},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init+=0.4')

      scene8_1.addLabel('init')
      .fromTo($scene8.find('.c13_tit'), 20/30,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene8.find('.c13_txt'), 0.8,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.5)
      .fromTo($scene8.find('.c13_light'), 20/30,{autoAlpha:0, scale: 0.5},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene8.find('.c13_tit_dero_l'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene8.find('.c13_tit_dero_r'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene8.find('.c13_bg'), 19/30,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.5)
      .fromTo($scene8.find('.c13_img1'), 0.7,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene8.find('.c13_img2'), 0.7,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.8)
      .fromTo($scene8.find('.c13_img3'), 0.7,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.9)
      .fromTo($scene8.find('.c13_img4'), 0.7,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+1.0)
      .fromTo($scene8.find('.c13_img1_line'), 0.3,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+1.1)
      .fromTo($scene8.find('.c13_img2_line'), 0.3,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+1.1)
      .fromTo($scene8.find('.c13_img3_line'), 0.3,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+1.1)
      .fromTo($scene8.find('.c13_img4_line'), 0.3,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+1.1)
      .fromTo($scene8.find('.c13_cont'), 1,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+1.2)
      
      scene8_2.addLabel('init')
      .fromTo($scene8.find('.c14_tit'), 20/30,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene8.find('.c14_txt'), 0.8,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.5)
      .fromTo($scene8.find('.c14_light'), 20/30,{autoAlpha:0, scale: 0.5},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene8.find('.c14_tit_dero_l'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene8.find('.c14_tit_dero_r'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene8.find('.c14_img1'), 19/30,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene8.find('.c14_img2'), 19/30,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene8.find('.c14_img3'), 19/30,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene8.find('.c14_img4'), 19/30,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene8.find('.c14_img5'), 19/30,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.7)
           
      scene8_3.addLabel('init')
      .fromTo($scene8.find('.c15_tit'), 20/30,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene8.find('.c15_txt'), 0.8,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.5)
      .fromTo($scene8.find('.c15_light'), 20/30,{autoAlpha:0, scale: 0.5},{ autoAlpha:1, scale: 1, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene8.find('.c15_tit_dero_l'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene8.find('.c15_tit_dero_r'), 20/30,{autoAlpha:0,  y:0},{autoAlpha:1, y:0, ease: Power2.easeOut }, 'init+='+0.6)
      .fromTo($scene8.find('.c15_img1'), 19/30,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene8.find('.c15_img2'), 19/30,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene8.find('.c15_img3'), 19/30,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.7)
      .fromTo($scene8.find('.c15_img4'), 19/30,{autoAlpha:0},{ autoAlpha:1, ease: Power2.easeOut }, 'init+='+0.7)
    },
    setSequence : function() {
      
    },
    controls: function() {
      var context = this;
      $('.js-btn_scroll').on('click', function() {
        context.page.to(1);
        return false;
      })
      $('#menu a').on('click', function(e) {
          if ($(this).attr('href')== "#") {
          
            var num = $(this).data('anchor');

            if (!($(this).data('anchor') >-1)) {
                num = $(this).siblings('ul').find('a').eq(0).data('anchor');
            }

            if (context.page.nowIndex != num) {
              context.page.to(num);
            }
            return false;
          }
      });
      $('#village .tab_menu a').on('click', function() {
        var idx = $('#village .tab_menu a').index($(this));
        $('#village .tab_menu a').removeClass('on');
        $(this).addClass('on');
        context.slider.village_swiper.slideTo(idx);
        return false;
      });
      
      //====  reboot1
      $('#reboot1 .tab_menu a').on('click', function() {
        var idx = $('#reboot1 .tab_menu a').index($(this));
        $('#reboot1 .tab_menu a').removeClass('on');
        $(this).addClass('on');
        context.slider.reboot1cont.slideTo(idx);
        return false;
      });
      
      TweenMax.set( $("#reboot1 .c6itme-list .c6_tip"), {autoAlpha:0, display:"none"});
      $("#reboot1 .c6itme-list a").hover(function(){
        var _tar = $(this).siblings(".c6_tip");
        TweenMax.to(_tar,0.3, {autoAlpha:1 , y:10, display:"block"});
      },function(){
        var _tar = $(this).siblings(".c6_tip");
        TweenMax.to(_tar,0.2, {autoAlpha:0, y:0, display:"none"});
      })


      //====  reboot2
      $('#reboot2 .tab_menu a').on('click', function() {
        var idx = $('#reboot2 .tab_menu a').index($(this));
        $('#reboot2 .tab_menu a').removeClass('on');
        $(this).addClass('on');
        context.slider.reboot2cont.slideTo(idx);
        return false;
      });

      //====  reboot3
      $('#reboot3 .tab_menu a').on('click', function() {
        var idx = $('#reboot3 .tab_menu a').index($(this));
        $('#reboot3 .tab_menu a').removeClass('on');
        $(this).addClass('on');
        context.slider.reboot3cont.slideTo(idx);
        return false;
      });

      //====  reboot4
      var subSwiper12_popArray = [
        _path+"img/pc/reboot4/emoticon/e001.gif",
        _path+"img/pc/reboot4/emoticon/e002.gif",
        _path+"img/pc/reboot4/emoticon/e003.gif",
        _path+"img/pc/reboot4/emoticon/e004.gif",
        _path+"img/pc/reboot4/emoticon/e005.gif",
        _path+"img/pc/reboot4/emoticon/e006.gif",
        _path+"img/pc/reboot4/emoticon/e007.gif",
        _path+"img/pc/reboot4/emoticon/e008.gif"
      ];
      function preloading (imageArray) { let n = imageArray.length; for (let i = 0; i < n; i++) { let img = new Image(); img.src = imageArray[i]; } }
      preloading(subSwiper12_popArray);
      $("#reboot4 .c11_box a").hover(function(){
        $("img",this).attr("src", $(this).data("m"))
      },function(){
        $("img",this).attr("src", $(this).data("e"))
      });
      $(".c11_btn").click(function(){
        window.location.href = 'https://lineage.plaync.com/board/notice/view?articleId=5fd96774a8b8ed00019c421b&categoryId=0&viewMode=list&size=20';
      });


      //====  dungeon2
      $('#dungeon2 .tab_menu a').on('click', function() {
        var idx = $('#dungeon2 .tab_menu a').index($(this));
        $('#dungeon2 .tab_menu a').removeClass('on');
        $(this).addClass('on');
        context.slider.dungeon2cont.slideTo(idx);
        return false;
      });

    },
    remote: function(target) {

      var $menu = $('#menu');
      var $bullet = $menu.find('a[data-anchor]');
      $menu.find('a').removeClass('on');
      $bullet.removeClass('on').eq(target ).addClass('on');
      
      var _ul = $bullet.eq(target).closest('ul');
      if (_ul.length) {
          _ul.siblings('a').addClass('on');
      }
      $menu.removeClass().addClass('active-' + target);
    },
    resize: function() {
      var context = this;
      $(window).resize(function() {
          sh = $(window).height();
          if (context.state.resizeTimer) {
              clearTimeout(context.state.resizeTimer);
          }
          context.state.resizeTimer = setTimeout(function() {
              context.state.resizeTimer = null;
              context.layout();
          }, 100);
      }).resize();
    }
  }
  return Lineage_UPDATE;

})();


promokit.preload({
  game: 'lineage',
  complete: function () {

  }
});


window.update = new Aniversary({
  el: "#scene-box",
  idx: 0,
  before: 0,
  wheelsp: 1200
});



// WEBPACK FOOTER //
// ./src/js/index_v3.js